const mergeDocumentsAndFolders = (documents, folders) => {
  const docsWithFolder = documents.filter(doc => doc.folderId);
  const docsWithoutFolder = documents.filter(doc => !doc.folderId);

  const mergedFolders = folders.map(folder => ({
    ...folder,
    documents: docsWithFolder.filter(doc => doc.folderId === folder.id),
  }));

  if (docsWithoutFolder.length > 0) {
    mergedFolders.push({
      id: 'without-folder',
      name: 'Without Follder',
      documents: docsWithoutFolder,
    });
  }

  return mergedFolders;
};

export default mergeDocumentsAndFolders;
